<template>
  <div>
    <div v-if="hasSomeRole(['DEALER', 'DEALER_L2'])" class="content-header">
      <h1>Prehľad</h1>
    </div>
    <section class="content" v-if="hasSomeRole(['DEALER', 'DEALER_L2'])">
      <div class="row" v-if="!loading">
        <div class="col-md-6">
          <div class="box box-default">
            <div class="box-header with-border">
              Plán výroby na dnes - {{ now | date }}
            </div>
            <div class="box-body">
              <table v-if="orders" class="table table-hover">
                <thead>
                  <th></th>
                  <th v-for="product in validProducts">{{ product.label }}</th>
                </thead>
                <tbody>
                  <template v-for="businessType in businessTypes">
                    <tr>
                      <td>{{ businessType.label }}</td>
                      <td v-for="product in validProducts">{{ count(now, product, businessType) }}</td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr class="info text-bold">
                    <td>Spolu</td>
                    <td v-for="product in validProducts">{{ count(now, product) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box">
            <div class="box-header with-border">
              Plán výroby na zajtra - {{ tomorrow | date }}
            </div>
            <div class="box-body">
              <table class="table table-hover">
                <thead>
                <th></th>
                <th v-for="product in validProducts">{{ product.label }}</th>
                </thead>
                <tbody>
                  <template v-for="businessType in businessTypes">
                    <tr>
                      <td>{{ businessType.label }}</td>
                      <td v-for="product in validProducts">{{ count(tomorrow, product, businessType) }}</td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr class="info text-bold">
                    <td>Spolu</td>
                    <td v-for="product in validProducts">{{ count(tomorrow, product) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <loading id="orders"></loading>
    </section>
  </div>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';
  import {mapGetters, mapState} from 'vuex';
  import { businessTypes } from 'codelist/';
  import loading from 'components/loading';

  export default {
    components: { loading },
    data: () => ({
      now: moment().startOf('d'),
      tomorrow: moment().add(1, 'd').startOf('d'),
      businessTypes: businessTypes,
    }),
    computed: {
      ...mapState({
        loading: (state) => state.app.loadingData.orders,
        orders: (state) => state.order.items
      }),
      ...mapGetters({
        hasSomeRole: 'auth/hasSomeRole',
        validProducts: 'product/validItems'
      })
    },
    methods: {
      count(date, product, businessType) {
        let orders = _(this.orders);
        if (businessType) {
          orders = orders.filter(order => order.customer.businessType === businessType.value);
        }
        return orders.filter(order => order.date.isSame(date, 'd'))
          .flatMap('items')
          .filter(orderItem => orderItem.product.id === product.id)
          .sumBy('amount');
      }
    },
    created() {
      if (this.hasSomeRole(['DEALER', 'DEALER_L2'])) {
        this.$store.dispatch('product/getAll');
      }
    },
    mounted() {
      if (this.hasSomeRole(['DEALER', 'DEALER_L2'])) {
        this.$store.dispatch('order/findByDateRange', {dateFrom: this.now, dateTo: this.tomorrow});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/overview.vue